export enum enumsGenerals{
    user_manager_proform = "GERENTE",
    user_administrator = "ADMINISTRADOR"
}